export default __webpack_public_path__ + "static/media/Riu_TM_Logo.89974744.png";